import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BettingGamesHttpService} from '@api/http/betting-games/betting-games-http.service';
import {LeagueHttpService} from '@api/http/league/league-http.service';
import {IBettingGame} from '@api/models/betting-game/betting-game';

@Component({
  selector: 'lib-betting-game-teaser',
  templateUrl: './betting-game-teaser.component.html',
  styleUrls: ['./betting-game-teaser.component.scss']
})
export class BettingGameTeaserComponent implements OnInit {

  @Input() public leagueId: string;
  @Output() public bettingGameClick = new EventEmitter();
  public bettingGame: IBettingGame = null;
  public noLink = false;

  constructor( private bettingGameService: BettingGamesHttpService,
               private leagueService: LeagueHttpService ) { }

  async ngOnInit(): Promise<void> {
    this.bettingGame = await this.leagueService.getLeagueBettingGame(this.leagueId);
  }
}
